import {
  Flex,
  FlexProps,
  Box,
  BoxProps,
  Heading,
  Text,
  Avatar,
  Skeleton,
  SkeletonCircle,
  HTMLChakraProps,
  forwardRef,
  HStack,
} from '@chakra-ui/react';
import Image from 'next/image';
import { FC, ReactNode } from 'react';

const wrapperStyles: FlexProps = {
  w: 'full',
  justify: 'start',
  alignItems: 'center',
  textAlign: 'left',
};

const infoContainerStyles: BoxProps = {
  minW: 0,
  flex: 1,
  pl: 4,
};

interface IProfileInfoProps extends HTMLChakraProps<'div'> {
  fullName: string;
  avatarUrl: string;
  title?: string;
  rightIcon?: ReactNode;
  fullNameSuffix?: ReactNode;
}

export const ProfileInfo = forwardRef<IProfileInfoProps, 'div'>(
  ({ fullName, title, avatarUrl, rightIcon, fullNameSuffix, ...rest }, ref) => (
    <Flex ref={ref} {...wrapperStyles} {...rest}>
      {!avatarUrl && <Avatar bg="violet.500" color="white" size="md" name={fullName} src={avatarUrl} />}
      {avatarUrl && <Image src={avatarUrl} alt={fullName} width={40} height={40} style={{ borderRadius: '50%' }} />}
      <Box {...infoContainerStyles}>
        <HStack spacing={0}>
          <Heading noOfLines={2} fontSize="md" lineHeight="base" whiteSpace="break-spaces">
            {fullName}
          </Heading>
          {fullNameSuffix}
        </HStack>
        {title && (
          <Text
            fontWeight="normal"
            fontSize="xs"
            lineHeight={4}
            color="gray.800"
            whiteSpace="break-spaces"
            noOfLines={2}
          >
            {title}
          </Text>
        )}
      </Box>
      {rightIcon}
    </Flex>
  )
);

export const ProfileInfoSkeleton: FC<HTMLChakraProps<'div'>> = (props) => (
  <Flex {...wrapperStyles} {...props}>
    <SkeletonCircle size="80px" />
    <Box {...infoContainerStyles}>
      <Skeleton w="150px" h="16px" my={1} />
      <Skeleton w="full" h="12px" my={1} />
    </Box>
  </Flex>
);

export const CommentProfileInfoSkeleton: FC<HTMLChakraProps<'div'>> = (props) => (
  <Flex {...wrapperStyles} {...props}>
    <SkeletonCircle size="40px" />
    <Box {...infoContainerStyles}>
      <Skeleton w="150px" h="16px" my={1} />
      <Skeleton w="full" h="12px" my={1} />
    </Box>
  </Flex>
);
